export default __webpack_public_path__ + "static/media/les_viewstrike.f60a25e3.svg";